import i18n from 'modules/core/lib/i18n'
import { StatusVariant } from '@factorialco/f0-react'
import { FinanceValueObjectsBudgetMovementStatusEnum } from 'generated/resources/graphql'

export const paymentStatusVariant = (
  status: FinanceValueObjectsBudgetMovementStatusEnum
): StatusVariant => {
  switch (status) {
    case 'draft':
      return 'neutral'
    case 'pending':
      return 'warning'
    case 'spent':
      return 'positive'
    case 'rejected':
      return 'critical'
    default:
      return 'neutral'
  }
}

export const paymentStatusLabel = (status: FinanceValueObjectsBudgetMovementStatusEnum): string => {
  switch (status) {
    case 'draft':
      return i18n.t('budgets.budget_movement_status.draft')
    case 'pending':
      return i18n.t('budgets.budget_movement_status.pending')
    case 'spent':
      return i18n.t('budgets.budget_movement_status.spent')
    case 'rejected':
      return i18n.t('budgets.budget_movement_status.rejected')
  }
}
